import React, { useState, useEffect } from "react";
import axios from "axios";
import Dotdotdot from "../../../utils/Helpers/DotDotDot";
import ValueContainerSecondColor from "../../../layouts/ViewContainers/ValueContainerSecondColor";
import { withRouter } from "react-router-dom";
import injectSheet, { withTheme } from "react-jss";
import { OfficeIcon } from "../../../assets/icons/Icons";
import { formatOrgNo } from "../../../utils/helpers";
import { GetUser } from "../../../utils/UserFunctions";
import { GetData } from "../../../utils/axios";
import { useDispatch } from "react-redux";
import { changeSelectedSmvp } from "../../../redux/actions/user";

const SamverkanspartItem = (props) => {
  const [samverkanspart, setSamverkanspart] = useState(props.samverkanspart);
  const [cancelToken, setCancelToken] = useState(axios.CancelToken.source());
  const { classes } = props;
  const dispatch = useDispatch();

  useEffect(() => {
    if (props.samverkanspart) {
      setSamverkanspart(props.samverkanspart);
    }
    return () => {
      if (cancelToken) {
        cancelToken.cancel();
      }
    };
  }, [props.samverkanspart]);

  const handleClick = async () => {
    if (samverkanspart?.id === props.selectedSamverkanspart?.id) {
      return;
    }
    //dispatch(changeSelectedSmvp(null));
    if (cancelToken) {
      cancelToken.cancel();
    }
    let cToken = axios.CancelToken.source();
    setCancelToken(cToken);
    const data = await GetData(
      "/samverkanspart/" + samverkanspart?.id + "?fullObject=true",
      cToken
    );
    if (data) {
      let storage = {
        userID: GetUser().id,
        samvId: samverkanspart?.id,
      };
      let saveData = {
        storage: storage,
        selectedSamverkanspart: data,
      };
      dispatch(changeSelectedSmvp(saveData));
      //dispatch(changeSelectedSmvp(data));
      props.history.push("/samverkansparts");
      props.closePopup();
    }
  };

  return (
    <div
      style={{
        backgroundColor:
          samverkanspart?.id === props.selectedSamverkanspart?.id
            ? "#eaeaea"
            : "",
      }}
    >
      <button onClick={handleClick} className={classes.btn}>
        <div style={{ marginRight: "16px" }}>
          <OfficeIcon
            size="20px"
            color={
              samverkanspart.laskvitterad ? "#999494" : props.theme.themeColor
            }
          />
        </div>
        <div style={{ flex: 1, overflow: "hidden" }}>
          <div className={classes.messageContainer}>
            <Dotdotdot>
              <span className={classes.title}>{samverkanspart.message}</span>
            </Dotdotdot>
          </div>
          <div style={{ margin: "4px 0 7px 0" }}>
            <Dotdotdot>{samverkanspart.namn}</Dotdotdot>
          </div>
          <Dotdotdot>
            <div className={classes.bottomContainer}>
              <ValueContainerSecondColor>
                Organisationsnummer:&nbsp;
                <span style={{ fontWeight: 500, color: "#353c43" }}>
                  {formatOrgNo(samverkanspart.orgNr)}
                </span>
              </ValueContainerSecondColor>
            </div>
          </Dotdotdot>
        </div>
      </button>
    </div>
  );
};
const styles = {
  title: {
    fontWeight: 500,
    fontSize: "14px",
    color: "black",
    whiteSpace: "break-spaces",
  },
  messageContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    color: "#353c43",
  },
  bottomContainer: {
    display: "flex",
    justifyContent: "space-between",
  },
  btn: {
    border: 0,
    borderBottom: "solid 1px #dbe0e8!important",
    textAlign: "left!important",
    padding: "16px 8px 14px 16px!important",
    margin: "0!important",
    display: "flex",
    width: "100%",
    backgroundColor: "transparent",
    alignItems: "center",
    "&:hover": {
      backgroundColor: "#c3d7ec!important",
    },
  },
};
export default withRouter(withTheme(injectSheet(styles)(SamverkanspartItem)));
